import { init, makeAppWithCustomComponents } from '@boschebike/dodo/browser-lib';
import customComponents from './serverComponents.js';

const main = async () => {
  const App = makeAppWithCustomComponents(customComponents);
  init(App);
};

main();
